import { render, staticRenderFns } from "./TruckTemplates.vue?vue&type=template&id=d54cdf3c"
import script from "./TruckTemplates.vue?vue&type=script&lang=ts"
export * from "./TruckTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports